import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { StylesProvider } from "@material-ui/core/styles";

import StartRoute from "./routes/start";
import ResultRoute from "./routes/result";
import store from "./store/setup";
import theme from "./theme";
import "./App.css";

const App = () => {
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <Router>
            <Switch>
              <Route path="/" component={StartRoute} exact />
              <Route path="/result" component={ResultRoute} exact />
            </Switch>
          </Router>
        </Provider>
      </ThemeProvider>
    </StylesProvider>
  );
};

export default App;
